import React from 'react'
import InputGroup from './InputGroup'

const Input = (forwadedProps) => {
  return (
    <input
      className="text-input"
      {...forwadedProps}
    />
  )
}

const TextInput = (props) => {
  return <InputGroup Component={Input} {...props} />
}

export default TextInput
